import { OpenInBrowser, Save } from '@mui/icons-material';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

export default function BasicBlogButtons({
  blog,
  handleEdit,
  isBuilding,
  buildProgress,
}) {
  return (
    <>
      <div className="py-2">
        <Divider />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-sm-12 col-12 p-1">
            <a
              href={`https://${blog.id}.truvvl.blog/api/preview`}
              target="_blank"
              rel="nofollow noreferrer noopener"
            >
              <Button fullWidth variant="outlined" color="primary">
                Open site <OpenInBrowser className="ml-2" />
              </Button>
            </a>
          </div>
          {new Date(blog.expiryDate) > new Date() && (
            <div className="col-md-6 col-sm-12 col-12 p-1">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleEdit}
                disabled={isBuilding && buildProgress < 100}
              >
                Save changes <Save className="ml-2" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
